import React from 'react';
import PropTypes from 'prop-types';

import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, Col, Nav, Row, Tab } from 'react-bootstrap-5';
import Ownership from '../../call_list/owners/ownership';
import OwnerNameDisplay from './owner-name-display';

export default function TabbedOwnerList({ activeKey, owners, setActiveKey }) {
  return (
    <Tab.Container activeKey={activeKey} id="left-tabs-example" onSelect={setActiveKey} >
      <Row>
        <Col>
          <Nav className="nav-pills flex-column">
            {owners.map(owner => (
              <Nav.Link
                className="text-start rounded-1 border-0"
                eventKey={owner.id}
                key={owner.id}
              >
                <OwnerNameDisplay name={owner.contact.name}>
                  <Col xs="auto">
                    <FontAwesomeIcon icon={faChevronRight} />
                  </Col>
                </OwnerNameDisplay>
              </Nav.Link>
            ))}
          </Nav>
        </Col>
        <Col>
          <Card>
            <Card.Body>
              <Tab.Content>
                {owners.map(owner => (
                  <Tab.Pane eventKey={owner.id} key={owner.id}>
                    <Ownership owner={owner} />
                  </Tab.Pane>
                ))}
              </Tab.Content>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Tab.Container>
  );
}

TabbedOwnerList.propTypes = {
  activeKey: PropTypes.string,
  owners: PropTypes.array.isRequired,
  setActiveKey: PropTypes.func.isRequired,
};